import { createSelector } from "reselect";
import { StoreState } from "Store/Reducers";

const getAllBusinessUnitFromState = ({ business_units }: any): any[] => business_units?.saved;
export const getAllBusinessUnit = createSelector(getAllBusinessUnitFromState, (getAllBusinessUnitFromState) => getAllBusinessUnitFromState);

const getAllBusinessUnitMetaFromState = ({ business_units }: any): any[] => business_units?.meta;
export const getAllBusinessUnitMeta = createSelector(getAllBusinessUnitMetaFromState, (getAllBusinessUnitMetaFromState) => getAllBusinessUnitMetaFromState);

const getBusinessUnitValuesByIdFromState = ({ business_units }: any, candidateId: any): any => {
    const candidateKeys = Object.keys(business_units?.unsaved);

    let saved = business_units?.saved?.[candidateId];
    if (candidateKeys.length === 0) return {...saved};

    let newValues: any = [];

    for (let key of Object.keys(business_units?.unsaved?.[candidateId])) {
        let item = business_units?.unsaved?.[candidateId]?.[key];

        if (item.id) continue; 

        newValues.push({
            id: item.id,
            field_id: key,
            entity_id: candidateId,
            value: item.value
        });
    }

    let adjustedValues = saved?.values?.map((value: any) => {
        if (!business_units?.unsaved?.[candidateId]) return value;
        if (!business_units?.unsaved?.[candidateId]?.[value.field_id]) return value;

        return {
            ...value,
            value: business_units?.unsaved?.[candidateId]?.[value.field_id]?.['value']
        }
    });

    return {
        ...saved,
        values: [...newValues, ...adjustedValues]
    };
};
export const getBusinessUnitValuesById = createSelector(getBusinessUnitValuesByIdFromState, (getBusinessUnitValuesByIdFromState) => getBusinessUnitValuesByIdFromState);

const getBusinessUnitUnsavedChangesByIdFromState = ({ business_units }: any, candidateId: any): any[] => business_units?.unsaved[candidateId];
export const getBusinessUnitUnsavedChangesById = createSelector(getBusinessUnitUnsavedChangesByIdFromState, (getBusinessUnitUnsavedChangesByIdFromState) => getBusinessUnitUnsavedChangesByIdFromState);


const getBusinessUnitEntityByIdFromState = ({ business_units }: any, candidateId: any): any[] => business_units?.saved[candidateId]?.entity[0];
export const getBusinessUnitEntityById = createSelector(getBusinessUnitEntityByIdFromState, (getBusinessUnitEntityByIdFromState) => getBusinessUnitEntityByIdFromState);

const getAllBusinessUnitStatussesByIdFromState = ({ business_units }: any, candidateId: any): any[] => business_units?.saved[candidateId]?.status;
export const getAllBusinessUnitStatussesById = createSelector(getAllBusinessUnitStatussesByIdFromState, (getAllBusinessUnitStatussesByIdFromState) => getAllBusinessUnitStatussesByIdFromState);

























const getDatasets = ({business_units}: StoreState) => business_units.datasets; 
export const getBusinessUnitDataset = createSelector(getDatasets, ({entities}) => entities);
export const getBusinessUnitDatasetKeys = createSelector(getDatasets, ({ids}) => ids);

const getNewBusinessUnitIdFromState = ({ business_units }: any): any[] => business_units?.new;
export const getNewBusinessUnitId = createSelector(getNewBusinessUnitIdFromState, (getNewBusinessUnitIdFromState) => getNewBusinessUnitIdFromState);



const fetchRecords = ({ business_units }: StoreState) => business_units;
const byId = (_: StoreState, id) => id

export const getBusinessUnitById = createSelector(
    fetchRecords,
    byId,
    ({ entities }, id) => entities?.[id]
);

export const getBusinessUnitByIdAsObject = createSelector(
    fetchRecords,
    ({ entities }) => entities
)

export const getBusinessUnitCreateFlowId = createSelector(
    fetchRecords,
    ({ createFlowId }) => createFlowId
)

export const isBusinessUnitFetching = createSelector(
    fetchRecords,
    ({ _isFetching }) => _isFetching
)

export const isBusinessUnitDatasetFetching = createSelector(
    fetchRecords,
    ({ datasets: { _isFetching } }) => _isFetching
)

export const getBusinessUnitValues = createSelector(
    fetchRecords,
    ({ valuesByEntityIdByFieldId }) => valuesByEntityIdByFieldId
)

export const getBusinessUnitValuesByIdV2 = createSelector(
    fetchRecords,
    (_, record_id) => record_id,
    ({ valuesByEntityIdByFieldId }, record_id) => valuesByEntityIdByFieldId?.[record_id]
)